import { MspInProductTrialsStartTrialPopUpWebComponent } from './component/MspInProductTrialsStartTrialPopUpWebComponent';
import { WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_START_TRIAL_FORM } from '../../../webcomponents.constants';

export { MspInProductTrialsStartTrialPopUpWebComponent };

window.customElements.define(
  WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_START_TRIAL_FORM,
  MspInProductTrialsStartTrialPopUpWebComponent
);
